module.exports = __webpack_public_path__ + "media/img/pages/profile/aldi ger 7-d03c179c5c323900f5b82bfde48afe77.jpg";